<template>
	<div class="service">
		<div class="service__method">
			<div class="service__method__title">
				<div class="service__method_cn">铺贴方法 / </div>
				<div class="service__method_en">Paving method</div>
				<img src='https://static.zc0901.com/dci-web-product-knowledge.png' class="service__method_bottom" />
			</div>
			<img class="service__method__img" src='https://static.zc0901.com/dci-web-method-img.png' />
			<div class="service__method__bottom">
				<div class="service__method__bottom_left">
					<div v-for="(item,index) in left" :key="index">{{item}}</div>
				</div>
				<div class="service__method__bottom_left">
					<div v-for="(item,index) in right" :key="index">{{item}}</div>
				</div>
			</div>
		</div>
		<div class="service__maintenance">
			<div class="service__method__title">
				<div class="service__method_cn">产品保养 / </div>
				<div class="service__method_en">Product maintenance</div>
				<img src='https://static.zc0901.com/dci-web-product-knowledge.png' class="service__method_bottom" />
			</div>
			<img class="service__maintenance__top__img" src='https://static.zc0901.com/dci-web-maintenance-top.png' />
			<img class="service__maintenance__bottom__img" src='https://static.zc0901.com/dci-web-maintenance-bottom.png' />
			<div class="service__method__content">
				<div>意大利DCI品牌的产品维护，根据用途而异。加高地面，考虑到地板下存在的电线等设备，应当避免使用水或过量蒸汽，建议使用湿抹布。通风外墙，建议不要大面积泼水，以免损坏后边的隔热层并影响其隔热功能。用粘合剂铺贴的砖，需要施工后清洁、日常保养以及非日常保养。</div>
				<div>施工后清洁建议使用专用酸性清洁剂，注意使用清洁剂前，先用清水将砖弄湿，避免因酸而带来的缝隙损坏；在其他情况下，建议使用中性或碱性的去油清洁剂进行保养。</div>
			</div>
			<img class="service__maintenance__right__img" src='http://static.zc0901.com/dci-web-maintenance-right-img-new.png' />
		</div>
		<foot></foot>	
	</div>
</template>
<script>
import './index.scss'
import foot from '../../components/foot/index'

	export default {
		components:{
			foot
		},
		data() {
			return {
				left:[
					'1. 铺贴准备：确认基面状态为干燥、稳定、完全平整、干净； ',
					'2. 辅料选择：建议使用全瓷砖专用的瓷砖胶或者改良水泥基黏贴剂进行瓷砖铺贴；',
					'3. 基面贴合：使用带圆齿刮板将瓷砖胶均匀地涂在基面，保证瓷砖和基面的100%贴合；',
					'4. 瓷砖选择：开始铺砖时，选不同箱子里的砖试铺在地面（3-4平米以上），确认其整体效果。每片砖所存在的纹理及渐变色差异是产品本身的外观特点，建议在铺贴时随机选砖，确保铺贴效果更自然；'
				],
				right:[
					'5. 铺砖留缝：120x120cm规格瓷砖铺贴最少留3毫米缝隙；其他规格单一尺寸最少留2毫米缝隙、多规格组合铺贴最少留3毫米缝隙；',
					'6. 填缝处理：等瓷砖胶完全干燥后才开始填缝，填缝前需要确认缝里干净。填缝时，建议小面积（5平米以下）逐步处理，同步使用一块湿的、干净的海绵清洗还没干燥的多余填缝剂。使用跟瓷砖表面相同颜色的填缝剂，可以保证整个表面具有连续自然效果；',
					'7. 表面保护：瓷砖表面清洁干燥后用布料或者纸板覆盖保护，避免因后续装修环节导致瓷砖表面损坏或变脏。'
				]
			}
		},
		computed: {
			
		},
        created(){
            
        },
		mounted() {
		},
		methods: {}
	}
</script>
<style scoped lang="scss">
  
</style>
